// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Timer-cls1___19498bb0c2d626a2127{/*!*/}.Timer-cls2__c0e7be07ffa4da8581b7{color:#fff;font-weight:500;font-size:10px;letter-spacing:.16em;margin:0;text-align:center;text-transform:uppercase}.Timer-cls2__c0e7be07ffa4da8581b7.Timer-mini__ed5a7d6c8fd75a08538d{font-size:8px}.Timer-cls2__c0e7be07ffa4da8581b7.Timer-dark___3440a6475347dc58505{color:#4b4b4b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Timer-cls1___19498bb0c2d626a2127",
	"cls2": "Timer-cls2__c0e7be07ffa4da8581b7 Timer-cls1___19498bb0c2d626a2127",
	"mini": "Timer-mini__ed5a7d6c8fd75a08538d",
	"dark": "Timer-dark___3440a6475347dc58505"
};
export default ___CSS_LOADER_EXPORT___;
